import React from 'react';
import { TextField } from '../TextFieldStyled/TextField';
import { TextInputProps } from '../types';
import { AdminHTMLTooltip } from '../../styled/HtmlTooltip';
import { useTruncationTooltip } from '../../../hooks/useTruncationTooltip/useTruncationTooltip';
import { useTruncatedTextFieldStyles } from './styles';

/**
 * TextField that shows an ellipsis for values wider than the input and,
 * while the field is read-only (disabled), reveals the full value in a tooltip on hover.
 */
export const TruncatedTextField: React.FC<TextInputProps> = ({ inputProps, ...props }) => {
  const { classes, cx } = useTruncatedTextFieldStyles();
  const { ref, open, onOpen, onClose } = useTruncationTooltip<HTMLInputElement>();
  const value = typeof props.value === 'string' ? props.value : '';
  const isTooltipEnabled = Boolean(props.disabled && value);

  return (
    <AdminHTMLTooltip
      title={<span className={classes.tooltipContent}>{value}</span>}
      open={isTooltipEnabled && open}
      onOpen={onOpen}
      onClose={onClose}
      disableHoverListener={!isTooltipEnabled}
      disableFocusListener={!isTooltipEnabled}
      disableTouchListener={!isTooltipEnabled}
      placement="top"
    >
      <div className={classes.wrapper}>
        <TextField
          {...props}
          inputRef={ref}
          inputProps={{ ...inputProps, className: cx(classes.input, inputProps?.className) }}
        />
      </div>
    </AdminHTMLTooltip>
  );
};
